import { render, staticRenderFns } from "./AccessItem.vue?vue&type=template&id=52167a7b"
import script from "./AccessItem.vue?vue&type=script&lang=js"
export * from "./AccessItem.vue?vue&type=script&lang=js"
import style0 from "./AccessItem.vue?vue&type=style&index=0&id=52167a7b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports